import CarrierLogo from "@/Shared/Icons/CarrierLogo";
import { displayNameForCarrier } from "@/Data/displayNameForCarrier";
import type { QuoteLike } from "@/Shared/Quotes/Types/QuoteLikeType";
import type { Broker } from "@freightsimple/generated-dashboard-openapi-client/models/Broker";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

import { QuotesColumn } from "@/Shared/Quotes/CustomComponents/QuotesColumn";
import { QuotesColumnHeader } from "@/Shared/Quotes/CustomComponents/QuotesColumnHeader";
import { QuotesColumnSectionHeader } from "@/Shared/Quotes/CustomComponents/QuotesColumnSectionHeader";
import { QuotesSecondaryText } from "@/Shared/Quotes/CustomComponents/QuotesSecondaryText";

interface TransitColumnForTrackingProps {
  quote: QuoteLike;
  shipmentState: ShipmentState;
  proNumber: string | undefined;
  billOfLadingNumber?: string | undefined;
  notes?: string | undefined;
  broker?: Broker | undefined;
}
function QuotesTransitColumnForTracking(props: TransitColumnForTrackingProps) {
  const { quote, shipmentState } = props;

  const showCarrierLogo = !(
    shipmentState === ShipmentState.Quoted ||
    shipmentState === ShipmentState.QuoteRequested
  );

  const carrierDisplayName = displayNameForCarrier(quote.carrierIdentifier);

  const transitTimeDescription = quote.transitBusinessDays
    ? `${quote.transitBusinessDays} Business Days`
    : "Unknown";

  return (
    <QuotesColumn>
      <div className="flex flex-col items-start">
        <QuotesColumnHeader>Transit</QuotesColumnHeader>

        <QuotesColumnSectionHeader>Pro Number</QuotesColumnSectionHeader>
        <QuotesSecondaryText>{props.proNumber}</QuotesSecondaryText>
        {props.billOfLadingNumber && (
          <>
            <QuotesColumnSectionHeader>BOL Number</QuotesColumnSectionHeader>
            <QuotesSecondaryText>
              {props.billOfLadingNumber}
            </QuotesSecondaryText>
          </>
        )}

        <QuotesColumnSectionHeader>Carrier</QuotesColumnSectionHeader>
        {showCarrierLogo && (
          <div style={{ margin: "8px 0" }}>
            <CarrierLogo
              carrierIdentifier={quote.carrierIdentifier}
              align="left"
              width={160}
              height={64}
            />
          </div>
        )}
        {!showCarrierLogo && (
          <QuotesSecondaryText>{carrierDisplayName}</QuotesSecondaryText>
        )}

        <QuotesColumnSectionHeader>Transit Time</QuotesColumnSectionHeader>
        <QuotesSecondaryText>{transitTimeDescription}</QuotesSecondaryText>
      </div>
    </QuotesColumn>
  );
}
export default QuotesTransitColumnForTracking;
